module["exports"] = ["Sr.", "Sra.", "Srta.", "Dr.", "Dra."];